import ContentPage from './ContentPage';

const FAQS = [
  {
    q: 'How do I place an order?',
    a: 'Browse the store, add pieces to your bag (you’ll need to sign in), then submit your details on the cart page. We’ll follow up on WhatsApp to confirm.',
  },
  {
    q: 'Do I need an account?',
    a: 'Yes — an account keeps your bag, wishlist, and order conversations connected. Register with your email and phone, then shop.',
  },
  {
    q: 'How do sizes work?',
    a: 'Each product lists available sizes. Where a size chart is provided, open the product page to compare measurements before you add to bag.',
  },
  {
    q: 'Can I filter by fabric or colour?',
    a: 'Yes. On the products page, use Filters for category, collection, size, fabric type, and colour based on what’s in the catalogue.',
  },
  {
    q: 'How do I contact support?',
    a: 'Use the Contact section on the home page, or reach out via the WhatsApp details shared after you submit your bag.',
  },
];

export default function FaqsPage() {
  return (
    <ContentPage
      eyebrow="Help"
      title="FAQs"
      lead="Quick answers about shopping, sizing, and getting in touch with Nayavarnam."
    >
      <div className="content-page__faq">
        {FAQS.map((item) => (
          <details key={item.q}>
            <summary>{item.q}</summary>
            <p>{item.a}</p>
          </details>
        ))}
      </div>
    </ContentPage>
  );
}
